import { render, staticRenderFns } from "./features-media.vue?vue&type=template&id=46a3bbb1&scoped=true"
import script from "./features-media.vue?vue&type=script&lang=js"
export * from "./features-media.vue?vue&type=script&lang=js"
import style0 from "./features-media.vue?vue&type=style&index=0&id=46a3bbb1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46a3bbb1",
  null
  
)

export default component.exports